/**
 * @description Manage entities related to S3
 */
class MigrationService {
  /**
   * @description Service base URL (without trailing `/`)
   */
  public static base_url: string = import.meta.env.VITE_APP_MIGRATION_SERVICE_URL
  
  
  public static axios: any

  public static init (axiosInstance: any) {
    if(!MigrationService.base_url){
      throw "MigrationService base URL not set in env vars (VITE_APP_MIGRATION_SERVICE_URL)"
    }
    MigrationService.axios = axiosInstance 
  }

  public static list_migrations(namespace_id: number) {
    const url_params = {
      'namespace_id': namespace_id
    }
    return MigrationService.axios.get(`${MigrationService.base_url}/migrations`, { params: url_params })
  }

  public static get_migration(uuid: string, with_versions: boolean) {
    const url_params = {
      'uuid': uuid,
      'with_versions': Number(with_versions)
    }
    return MigrationService.axios.get(`${MigrationService.base_url}/migration`, { params: url_params })
  }

  public static estimate_migration(payload: any) {
    return MigrationService.axios.post(MigrationService.base_url+'/migrations/estimate', payload)
  }

  public static start_migration(payload: any) {
    return MigrationService.axios.post(MigrationService.base_url+'/migrations', payload)
  }

}

export default MigrationService
